import type { InputHTMLAttributes } from "react";
import { cx } from "../../lib/utils";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

// General-purpose default matching the reference mockups' search/filter
// field convention (Inbox's search box). A table header's own compact filter
// inputs (Leads screen) style themselves smaller via className overrides
// rather than a second variant here.
export function Input({ className, ...rest }: InputProps) {
  return (
    <input
      className={cx(
        "h-8 px-3 bg-surface-container-low focus:bg-surface-container-lowest text-on-surface font-body-sm text-body-sm rounded-xl outline-none transition-all placeholder:text-outline border border-transparent focus:border-primary",
        className
      )}
      {...rest}
    />
  );
}
